import React from "react"
import { CardDiv } from "./CardStyled"
import { CARD_PROPS } from "./interface"

export const CardComponent = ({
  children,
  width,
  height,
  background,
  size,
  suitSize,
  suitColor,
  pad,
  animDelay,
  deal,
  dealOut,
  win,
  isGameActive,
  name,
  showResult,
}: CARD_PROPS): JSX.Element => {
  return (
    <CardDiv
      animDelay={animDelay}
      deal={deal}
      dealOut={dealOut}
      isGameActive={isGameActive}
      width={width}
      height={height}
      background={background}
      size={size}
      suitSize={suitSize}
      suitColor={suitColor}
      pad={pad}
      win={win}
      name={name}
      showResult={showResult}
    >
      {children}
    </CardDiv>
  )
}
